import React, { useState } from 'react';

import * as S from './CompletedTab.styles';
import { Tab } from '../../../components';
import { RespondedTab } from './RespondedTab';
import { PostedTab } from './PostedTab';

export const CompletedTab = () => {
	const [tabs, setTabs] = useState([
		{
			id: 1,
			label: 'Responded',
			component: <RespondedTab />,
		},
		{
			id: 2,
			label: 'Posted',
			component: <PostedTab />,
		},
	]);

	return (
		<S.Wrapper>
			<Tab tabs={tabs} setTabs={setTabs} transparent variation="pill" />
		</S.Wrapper>
	);
};

CompletedTab.propTypes = {};
